module.exports = __webpack_public_path__ + "media/images/calculator-aki-onco/background_points-9bf4258863de2d277cfa4f2be862f772.svg";